import { useEffect, useState } from 'react';
import Markdown from './Markdown';

const Homepage = () => {
    const [content, setContent] = useState('');

    useEffect(() => {
        import(`../resources/${"homepage"}.md`) // TODO: check why this works and direct files don't
            .then(res => fetch(res.default))
            .then(res => res.text())
            .then(text => setContent(text))
            .catch(() => setContent('# Page not found'));
    }, []);

    return <Markdown content={content} />;
};

export default Homepage;
